enum SimStatus {
  UNSET_SIM_STATUS = 'UNSET_SIM_STATUS', // Do not use, needed because of proto3 limitations
  CREATED = 'CREATED', // SIM not linked to IMSI
  FROZEN = 'FROZEN', // SIM not in HSS
  COLD = 'COLD', // SIM in HSS but deactivated
  WARM = 'WARM', // SIM activated in HSS
  HOT = 'HOT', // SIM attached to the network
  SWAPPED = 'SWAPPED', // SIM has been swapped and is not used anymore
  PENDING_SWAP = 'PENDING_SWAP', // SIM swap in progress
  PENDING_SWAP_COLD = 'PENDING_SWAP_COLD', // SIM swap in progress for a cold SIM
  PENDING_SWAP_WARM = 'PENDING_SWAP_WARM', // SIM swap in progress for a warm SIM
  DELETED = 'DELETED',
  TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS'
}

export { SimStatus as SimonSimStatus };
